__turbopack_context__.v({
  "bottomSheet": "ModalCard-module-scss-module__Jo8XIa__bottomSheet",
  "fadeIn": "ModalCard-module-scss-module__Jo8XIa__fadeIn",
  "fadeInUp": "ModalCard-module-scss-module__Jo8XIa__fadeInUp",
  "fullScreen": "ModalCard-module-scss-module__Jo8XIa__fullScreen",
  "modalContent": "ModalCard-module-scss-module__Jo8XIa__modalContent",
  "modalHeader": "ModalCard-module-scss-module__Jo8XIa__modalHeader",
  "slideInUp": "ModalCard-module-scss-module__Jo8XIa__slideInUp",
});
